// One date format across the product. toLocaleString() renders differently on every
// machine — 13/09/2026 in India, 9/13/2026 in the US — so the same record read
// differently depending on who opened it. dd-MMM-yyyy removes the ambiguity entirely:
// 13-Sep-2026 cannot be misread as a day or a month whichever convention you expect.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const pad = (n) => String(n).padStart(2, '0');
const parsed = (value) => { const d = new Date(value); return Number.isFinite(d.getTime()) ? d : null; };

/** 13-Sep-2026 */
export const formatDate = (value, fallback = '—') => {
  const d = parsed(value);
  return d ? `${pad(d.getDate())}-${MONTHS[d.getMonth()]}-${d.getFullYear()}` : fallback;
};

/** 13-Sep-2026 14:05 — 24-hour, since am/pm is another thing that varies by locale. */
export const formatDateTime = (value, fallback = '—') => {
  const d = parsed(value);
  return d ? `${formatDate(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}` : fallback;
};

/**
 * Midnight where the plant is, as a timestamp.
 *
 * The server reckons "today" from midnight IST, because that is where the plant's day starts and
 * what its paperwork says. A browser in another timezone must not quietly disagree: a count of
 * trips opened today and the list behind that count have to cut the day at the same moment.
 */
export const plantMidnight = () => {
  const here = new Date();
  const offset = (here.getTimezoneOffset() + 330) * 60000;
  const plant = new Date(here.getTime() + offset);
  plant.setHours(0, 0, 0, 0);
  return plant.getTime() - offset;
};

/** 14:05 — for when the date is already established by its column or heading. */
export const formatTime = (value, fallback = '—') => {
  const d = parsed(value);
  return d ? `${pad(d.getHours())}:${pad(d.getMinutes())}` : fallback;
};
